import { z } from 'zod';
import { autoStatusFlagsSchema, workingHoursSchema } from './presence-status.js';
import { colorSchemeSchema, themeModeSchema } from './themes.js';
import { appIconSchema } from './app-icons.js';
import { richTextDocSchema } from './richtext.js';
import { MAX_MESSAGE_LENGTH } from './message.js';
import { directoryFieldsInput, nameDisplayModeSchema } from './user.js';
import { reminderRepeatKinds } from './recurrence.js';
import { repeatRuleSchema } from './reminder.js';
// ─── Profil es statusz ────────────────────────────────────────────────────────
export const updateProfileInput = directoryFieldsInput.extend({
    displayName: z.string().trim().min(1).max(80).optional(),
    /** Becenev; `null` a torleshez. */
    nickname: z.string().trim().max(80).nullable().optional(),
    /** A SAJAT dontesem: neveket vagy beceneveket latok a feluleten. */
    nameDisplay: nameDisplayModeSchema.optional(),
    timezone: z.string().max(60).optional(),
    statusEmoji: z.string().max(16).nullable().optional(),
    statusText: z.string().trim().max(120).nullable().optional(),
    statusExpiresAt: z.string().nullable().optional(),
    /** Fokusz mod vege; `null` = kikapcsolva. */
    focusUntil: z.string().nullable().optional(),
    /** Munkaido - ugyanez a sav donti el, mikor ertesitunk. */
    workingHours: workingHoursSchema.optional(),
    autoStatus: autoStatusFlagsSchema.optional(),
    themeMode: themeModeSchema.optional(),
    colorScheme: colorSchemeSchema.optional(),
    appIcon: appIconSchema.optional(),
    /** Profilkep: egy mar feltoltott fajl azonositoja, vagy `null` a torleshez. */
    avatarFileId: z.string().nullable().optional(),
});
// ─── Piszkozat ────────────────────────────────────────────────────────────────
export const draftSchema = z.object({
    channelId: z.string(),
    text: z.string(),
    body: richTextDocSchema.nullable(),
    updatedAt: z.string(),
});
export const saveDraftInput = z.object({
    text: z.string().max(MAX_MESSAGE_LENGTH),
    body: richTextDocSchema.optional(),
});
// ─── Utemezett uzenet ─────────────────────────────────────────────────────────
export const scheduledMessageSchema = z.object({
    id: z.string(),
    channelId: z.string(),
    parentId: z.string().nullable(),
    text: z.string(),
    body: richTextDocSchema.nullable(),
    isImportant: z.boolean(),
    /** Ismetlodonel a KOVETKEZO alkalom. */
    sendAt: z.string(),
    lastError: z.string().nullable(),
    /** Ismetlodes (versenyaudit U9); `kind: 'none'` = egyszeri. */
    repeat: repeatRuleSchema,
    /** Ismetlodonel a legutobbi feladas. */
    lastSentAt: z.string().nullable(),
});
export const scheduleMessageInput = z.object({
    text: z.string().min(1).max(MAX_MESSAGE_LENGTH),
    body: richTextDocSchema.optional(),
    parentId: z.string().nullable().optional(),
    /** A jeloles az idozitett uzenetet is elkiseri - lasd `sendMessageInput`. */
    isImportant: z.boolean().optional(),
    /** Az elso (vagy egyetlen) alkalom. */
    sendAt: z.string(),
    /**
     * Ismetlodes - ugyanaz, mint az emlekeztetonel: a zona a kuldo profiljabol
     * jon, nem a klienstol. Hianyzo mezo = egyszeri.
     */
    repeat: z
        .object({
        kind: z.enum(reminderRepeatKinds),
        days: z.array(z.number().int().min(0).max(6)).max(7).optional(),
        until: z.string().nullable().optional(),
    })
        .optional(),
});
/** Legalabb ennyivel kesobbre lehet idoziteni - kulonben nincs ertelme. */
export const MIN_SCHEDULE_LEAD_MS = 60_000;
/** Legfeljebb ennyire elore. */
export const MAX_SCHEDULE_AHEAD_MS = 90 * 24 * 60 * 60 * 1000;
// ─── Felhasznaloi csoportok ───────────────────────────────────────────────────
export const GROUP_HANDLE_RE = /^[a-z0-9_-]{2,40}$/;
export const userGroupSchema = z.object({
    id: z.string(),
    handle: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    memberIds: z.array(z.string()),
});
export const createGroupInput = z.object({
    handle: z.string().min(2).max(40),
    name: z.string().min(1).max(80),
    description: z.string().max(200).nullable().optional(),
    memberIds: z.array(z.string()).max(500).optional(),
});
export const updateGroupInput = z.object({
    name: z.string().min(1).max(80).optional(),
    description: z.string().max(200).nullable().optional(),
    memberIds: z.array(z.string()).max(500).optional(),
});
export const normalizeGroupHandle = (raw) => raw
    .trim()
    .toLowerCase()
    .replace(/^@/, '')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9_-]/g, '');
//# sourceMappingURL=workspace.js.map